<div>
    <b>TO</b>: {{ block.to }}
    <br>
    <b>件名</b>: {{ block.subject }}

</div>
